import React, { ChangeEvent, useState, useContext, FormEvent } from 'react';
import { useHistory } from 'react-router-dom';

import OwnerContext from '../../context/OwnerContext';
import { isOwnerStatusValid } from '../../helpers/AuthOwnerHelper';
import { ApiHttpServiceAnon } from '../../services/ApiServices';
import { OwnerLoginStage, StringValueType } from '../../helpers/EnumsInternal';
import { IsMobileOrEmail } from '../../helpers/TextCheckers';
import MainErrorText from '../../components/MainErrorText';
import { ErrorDanish } from '../../helpers/ErrorDanish';


type HeaderProps = {
    setInputMobileOrEmail: Function,
    showSpinner: Function,
    setOwnerLoginStage: Function,
    setLoginCodeId: Function
}

function OwnerConsentsFind(props: HeaderProps) {
    let {setInputMobileOrEmail, showSpinner, setOwnerLoginStage, setLoginCodeId} = props;

    const ownerLoginObject = useContext(OwnerContext);
    const history = useHistory();
    const [errorText, setErrorText] = useState<string>('');
    const [codeInputFieldValue, setCodeInputFieldValue] = useState<string>('');
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);


    function onInputFieldChange(inputCode: string) {
        inputCode = inputCode.replace(/\s/g, '');
        setCodeInputFieldValue(inputCode);
        setIsButtonDisabled(IsMobileOrEmail(inputCode) === StringValueType.Invalid);
    }

    async function handleFindClick(e: FormEvent) {
        e.preventDefault();
        showSpinner(true);
        setIsButtonDisabled(true);
        setErrorText('');
        
        let searchStringType: StringValueType = IsMobileOrEmail(codeInputFieldValue);
        
        if (searchStringType !== StringValueType.MobilePhone8 && searchStringType !== StringValueType.EmailAddress) {
            setErrorText(ErrorDanish["MobileOrEmailInvalid"]);
            setIsButtonDisabled(false);
            showSpinner(false);
        }
        else {
            // Check if already has a ownerStatus and it is not expired.
            if (isOwnerStatusValid(ownerLoginObject) && codeInputFieldValue === ownerLoginObject.ownerStatus.mobileOrEmail) {
                history.push('/consents');
                return;
            }

            setErrorText('');
            setInputMobileOrEmail(codeInputFieldValue);
            setIsButtonDisabled(true);
            showSpinner(true);

            let apiParam: string = "";
            if (searchStringType === StringValueType.MobilePhone8) {
                apiParam = "mobile/" + codeInputFieldValue;
            } else if (searchStringType === StringValueType.EmailAddress) {
                apiParam = "email/" + codeInputFieldValue;
            }

            await ApiHttpServiceAnon(`owners/${apiParam}/code`, 'GET')
            .then(result => {
                // No result returned.
                if (result === undefined || result === null) {
                    setErrorText(ErrorDanish["GeneralError"]);
                } else {
                    switch(result.status) {
                        case 200: // OK
                            result.json()
                                .then(resultJson => {
                                    // Generic write error.
                                    if (resultJson === undefined || resultJson === null) {
                                        setErrorText(ErrorDanish["DbFetchDataError"]);
                                    // Success.
                                    } else if (resultJson.loginCodeId > 0) {
                                        let loginCode = resultJson.loginCodeId;
                                        setLoginCodeId(loginCode);
                                        setOwnerLoginStage(OwnerLoginStage.Code);
                                    }
                                    // No consents found, but redirect anyhow.
                                    else {
                                        setOwnerLoginStage(OwnerLoginStage.Code);
                                    }
                                });
                            break;
                        case 429:   // Too Many Requests
                            setErrorText(ErrorDanish['TooManyRecentAttempts']);
                            break;
                        case 404:
                            setErrorText(ErrorDanish['NoConsentsOnOwnerLogin'] + codeInputFieldValue + '. ' + ErrorDanish['NoConsentsInputQuestion'] +
                                (IsMobileOrEmail(codeInputFieldValue) === StringValueType.MobilePhone8 ? 'dit nummer' : 'din email'));
                            break;
                        case 400:   // Bad Request
                        default:
                            setErrorText(ErrorDanish['DbFetchDataError']);
                            break;
                    }
                }

                setIsButtonDisabled(false);
                showSpinner(false);
            })
            .catch(e => {
                console.log("Something fishy happened: " + e);
                setErrorText(ErrorDanish["DbConxError"]);
                setIsButtonDisabled(false);
                showSpinner(false);
            });
        }
    }
    

    return (
        <form onSubmit={ handleFindClick }>
            { errorText !== '' && <MainErrorText errorText={errorText}  /> }
            <div className="input-container">
                <input id="ownerLoginValue" type="text" maxLength={200} autoFocus
                    onInput={(e: ChangeEvent<HTMLInputElement>) => onInputFieldChange(e.target.value)} />
                <label htmlFor="ownerLoginValue">Telefon eller e-mail</label>
                <button type="submit" className="btn btn-primary" disabled={isButtonDisabled}>fors&aelig;t</button>
            </div>
        </form>
    );
}

export default OwnerConsentsFind
